/**
 * 预览弹框组件
 * @author chenqunfeng
 * @since 18/06/06
 */

import './dialog.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Stat from '@fe/common/lib/stat';
import * as ajax from '@fe/common/lib/ajax';
import { cleanObj, sendStat } from 'utils/common';
import VARIABLE from 'constants/variable.json5';
import Dialog from 'components/dialog';
import * as SceneDialog from './scene-dialog';
import * as VideoDialog from './video-dialog';
import * as GameDialog from './game-dialog';

import oops from 'assets/images/oops.png';
import loading from 'assets/images/loading.gif';
import { checkYouzanBill } from 'api/opf';

const { bwsHost = '' } = window.RPCONFIG || {};

class PreviewDialog extends Component {
  static propTypes = {
    modalType: PropTypes.string,
    // 预览模版的前置依赖数据
    data: PropTypes.object,
    // 用户信息
    userInfo: PropTypes.object,
    // 预览模版列表的详细数据
    tpls: PropTypes.object,
    // 隐藏模态框函数
    hideModal: PropTypes.func,
    // 设置预览模版的详细数据函数
    setTemplate: PropTypes.func,
    // 设置模版的收藏状态
    setTplCollectionStatus: PropTypes.func,
    // 抽奖方式
    lotteryId: PropTypes.number,
    // 当前激活的模板tab页
    activeIndex: PropTypes.number,
  };

  // 构造函数
  constructor() {
    super();

    this.state = {
      // 订单号
      order: null,
      // 二维码显示与否
      qrcode: false,
      // 优惠券
      coupon: {},
      // 购买状态
      buyState: {},
      // lottery
      lotteryTemplate: [],
    };
  }

  // 隐藏
  hide() {
    const { hideModal } = this.props;
    const tplData = this.getTplData();
    const { showByUrl } = tplData;

    hideModal({ data: VARIABLE.PREVIEW_MODAL });
    if (showByUrl === VARIABLE.SHOW_BY_URL) {
      if (location.hash) {
        location.href = location.origin + location.pathname + '#';
      }
    }
  }

  // 显示预览二维码
  onQrcode() {
    this.setState({ qrcode: true });

    // 二维码hover次数统计
    sendStat(
      'RP_STORE',
      '模版市场',
      '模板中间页-二维码大图出现',
      Stat.ACTION_INIT,
      {
        id: 'web_mobanmarket_detail_QRCode_hover',
      }
    );
  }

  // 隐藏预览二维码
  offQrcode() {
    this.setState({ qrcode: false });
  }

  // 根据id获取模版数据
  getTplData() {
    const { data, tpls } = this.props;
    const { presetData } = data;
    const { id } = presetData;
    const tplData = {
      ...presetData,
      ...tpls[id],
    };
    return tplData;
  }

  // 获取模版购买状态
  getBuyState() {
    return (async () => {
      try {
        const { id, category } = this.props.data.presetData;
        const { userId, isYouzan, kdtId } = this.props.userInfo;
        const isLocalAppTpl = category === VARIABLE.LOCAL_TEMPLATE;
        const { lotteryId } = this.props;
        console.log('购买模板id = ' + lotteryId);

        if (!userId) {
          this.setState({
            buyState: {
              flag: '0',
              desc: '未购买',
              status: VARIABLE.SUCCESS,
            },
          });
          return;
        }

        const orderSn = this.state.order;
        const isGame = category === VARIABLE.RP_GAME;
        const params = isGame
          ? cleanObj({
              id,
              orderSn,
              lotteryId,
            })
          : cleanObj({
              id,
              orderSn,
              isLocalAppTpl,
            });
        let state;
        // 有赞处理逻辑
        if (isYouzan) {
          const flag = await checkYouzanBill(id, kdtId);
          state = flag ? { flag: '1' } : { flag: '0' };
        } else {
          const url = isGame
            ? `game/${orderSn ? 'check' : 'status'}`
            : `tpl/check`;

          state = await ajax.get(`${bwsHost}/api/order/${url}`, params, {
            credentials: true,
          });
        }

        this.setState({
          order: null,
          buyState: {
            ...state, // state签名： buyState = {flag: "0", desc: "未购买"}
            status: VARIABLE.SUCCESS,
          },
        });

        return state;
      } catch (err) {
        this.setState({
          order: null,
          buyState: {
            status: VARIABLE.ERROR,
          },
        });

        return VARIABLE.ERROR;
      }
    })();
  }

  // 购买模版
  buyTemplate() {
    return (async () => {
      const buyWin = window.open('', 'buyTemplate');
      try {
        const { lotteryId } = this.props;
        const { id, type } = this.props.data.presetData;
        const { couponId } = this.state.coupon;
        const isGame = type === VARIABLE.RP_GAME;

        const { url, order } = await ajax.get(
          `${bwsHost}/api/pay/${isGame ? 'game' : 'tpl'}/${id}`,
          isGame ? { lotteryId } : { couponId },
          { credentials: true }
        );

        // if (isGame) {
        this.setState({ order });
        // }

        buyWin.location.href = url;
      } catch (err) {
        buyWin.close();
        console.log('购买模版接口返回错误');
      }
    })();
  }

  // 购买本地导出模版
  buyLocalTemplate() {
    return (async () => {
      const buyWin = window.open('', 'buyTemplate');
      try {
        const { id } = this.props.data.presetData;
        const { userId } = this.props.userInfo;
        const params = cleanObj({
          id,
          userId,
        });
        const url = `/api/store/template/template/localBuy`;
        const buyTemplate = await ajax.get(url, params);

        buyWin.location.href = buyTemplate.url;
      } catch (err) {
        buyWin.close();
        console.log('购买模版接口返回错误');
      }
    })();
  }

  // 获取预览弹窗HTML模版
  getContent() {
    const couponStatus = this.state.coupon.status;
    const { category, tplPrice, tplOrganizePrice, status } = this.getTplData();

    // 模版数据请求失败
    if (status === VARIABLE.ERROR) {
      return (
        <div className="s-preview-failed">
          <img className="s-preview-oops" src={oops} />
          <span className="s-preview-oops-tips">OOPS！加载失败</span>
        </div>
      );
    }

    // 价格不为0,且不是企业模版和个人模版,则会请求优惠折扣价格
    if (
      tplPrice !== 0 &&
      tplOrganizePrice !== 0 &&
      category !== VARIABLE.MY_TPL &&
      category !== VARIABLE.ENTERPRISE &&
      category !== VARIABLE.LOCAL_TEMPLATE &&
      category !== VARIABLE.RP_GAME &&
      !couponStatus
    ) {
      return (
        <div className="s-preview-loading">
          <img src={loading} />
        </div>
      );
    }
    if (
      status === VARIABLE.SUCCESS ||
      category === VARIABLE.ENTERPRISE ||
      category === VARIABLE.MY_TPL ||
      category === VARIABLE.RP_GAME
    ) {
      return (
        <div className="s-preview">
          {this.getPreviewLeft()}
          {this.getPreviewRight()}
        </div>
      );
    }
  }

  // 获取作品预览左边模版,包含预览iframe,翻页按钮
  getPreviewLeft() {
    const { modalType = VARIABLE.PREVIEW_MODAL } = this.props;
    const tplData = this.getTplData();
    const opts = {
      state: this.state,
      tplData,
    };
    if (modalType === VARIABLE.PREVIEW_MODAL) {
      return SceneDialog.getPreviewLeft(opts);
    } else if (modalType === VARIABLE.PREVIEW_VIDEO_MODAL) {
      return VideoDialog.getPreviewLeft(opts);
    } else if (modalType === VARIABLE.PREVIEW_GAME_MODAL) {
      return GameDialog.getPreviewLeft(opts);
    }
  }

  // 获取作品预览右边HTML模版
  getPreviewRight() {
    const {
      modalType = VARIABLE.PREVIEW_MODAL,
      userInfo,
      setTplCollectionStatus,
      lotteryId,
      activeIndex,
    } = this.props;
    const tplData = this.getTplData();
    const opts = {
      state: this.state,
      tplData,
      userInfo,
      getBuyState: this.getBuyState.bind(this),
      buyTemplate: this.buyTemplate.bind(this),
      buyLocalTemplate: this.buyLocalTemplate.bind(this),
      setTplCollectionStatus: setTplCollectionStatus,
      getLotteryBuyList: this.getLotteryBuyList.bind(this),
      lotteryId,
      activeIndex,
    };
    if (modalType === VARIABLE.PREVIEW_MODAL) {
      return SceneDialog.getPreviewRight(opts);
    } else if (modalType === VARIABLE.PREVIEW_VIDEO_MODAL) {
      return VideoDialog.getPreviewRight(opts);
    } else if (modalType === VARIABLE.PREVIEW_GAME_MODAL) {
      return GameDialog.getPreviewRight(opts);
    }
  }

  // 获取抽奖购买列表
  getLotteryBuyList() {
    return (async () => {
      try {
        const { data, userInfo, setTemplate } = this.props;
        const { presetData } = data;
        const { category } = presetData;
        const { id } = presetData;
        const { userId, organizeId } = userInfo;
        const template = await setTemplate({
          id,
          userId,
          organizeId: organizeId,
          category,
        });
        if (category === VARIABLE.RP_GAME) {
          await this.setState({
            lotteryTemplate: template,
          });
        }
      } catch (e) {
        console.log(e);
      }
    })();
  }

  async componentDidMount() {
    const { data, userInfo, setTemplate } = this.props;
    const { presetData } = data;
    const { category } = presetData;

    if (category !== VARIABLE.MY_TPL && category !== VARIABLE.RP_GAME) {
      const { id } = presetData;
      const { userId, organizeId } = userInfo;

      await setTemplate({
        id,
        userId,
        organizeId: organizeId,
        category,
      });

      // 去除获取优惠券逻辑，保留更改状态 redmine #22482
      this.setState({
        coupon: {
          status: VARIABLE.ERROR,
        },
      });
    }

    window.addEventListener('hashchange', () => {
      if (location.hash) {
        location.reload();
      }
    });
  }

  render() {
    let style;
    const modal = false;
    const content = this.getContent();
    const { modalType } = this.props;

    if (modalType === VARIABLE.PREVIEW_MODAL) {
      style = {
        width: 925,
        height: 584,
      };
    } else if (modalType === VARIABLE.PREVIEW_VIDEO_MODAL) {
      style = {
        width: 1080,
        height: 500,
      };
    } else if (modalType === VARIABLE.PREVIEW_GAME_MODAL) {
      style = {
        width: 906,
        height: 584,
      };
    }

    return (
      <Dialog
        style={style}
        modal={modal}
        content={content}
        closeBtn={true}
        onClose={this.hide}
        parent={this}
      />
    );
  }
}

export default PreviewDialog;
